import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import authApiService from "../../services/auth-api.service";
import { roleRoutes } from "../../config/roleRoutes";

import "./Login.scss";
import logo from "../../assets/imgs/sysb_logo.svg";

const Login = () => {
  const navigate = useNavigate();
  const [roleName, setRoleName] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setErrorMessage("");

    try {
      const response = await authApiService.doLogin({
        roleName,
        password,
      });

      const roleCd = response.role_cd;
      const path = roleRoutes[roleCd];

      if (!path) {
        setErrorMessage("不明な役割です。");
        return;
      }
      navigate(path);
    } catch (error: any) {
      console.error("ログイン失敗:", error);
      setErrorMessage("役割またはパスワードに誤りがあります。");
    }
  };

  return (
    <>
      <div className="loginScreen">
        <div className="loginBox">
          <form onSubmit={handleLogin}>
            <div className="loginLogo">
              <img src={logo} alt="" />
            </div>
            <div className="loginInput">
              <div>役割</div>
              <input
                id="inputRoleName"
                ref={inputRef}
                value={roleName}
                onChange={(e) => setRoleName(e.target.value)}
                placeholder=""
              />
              <div>パスワード</div>
              <input
                id="password"
                type="password"
                className="inputPassword"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder=""
              />
              {errorMessage && (
                <div className="errorMessage">
                  <div>{errorMessage}</div>
                </div>
              )}
            </div>
            <button className="loginBtn">ログイン</button>
          </form>
        </div>
      </div>
    </>
  );
};

export default Login;
